/**
 * Generated bundle index. Do not edit.
 */

export * from './adapter-uri-builder-odata';
